"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = Menu;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _HorizontalFlex = require("./HorizontalFlex");

var _brockMuiTheme = _interopRequireDefault(require("../constants/brockMuiTheme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function addDivider(index, hasDividers, menuItems) {
  if (hasDividers && index !== menuItems.length - 1) {
    return (
      /*#__PURE__*/
      _react["default"].createElement("hr", {
        className: "divider divider--inset"
      })
    );
  }

  return null;
}

function Menu(props) {
  function onMenuItemClick(menuItemOnClick) {
    return function () {
      menuItemOnClick();
      props.onClose();
    };
  }
  /* eslint-disable complexity */


  return (
    /*#__PURE__*/
    _react["default"].createElement(_core.ThemeProvider, {
      theme: _brockMuiTheme["default"]
    },
    /*#__PURE__*/
    _react["default"].createElement(_core.Menu, {
      getContentAnchorEl: null,
      anchorEl: props.anchorElement,
      open: Boolean(props.anchorElement),
      onClose: props.onClose,
      anchorOrigin: props.anchorOrigin,
      transformOrigin: props.transformOrigin
    }, props.menuItems.map(function (menuItem, index) {
      if (menuItem.subActions) {
        var subActions = menuItem.subActions.map(function (subAction) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_core.MenuItem, {
              key: subAction.description,
              disabled: subAction.isDisabled || false,
              onClick: onMenuItemClick(subAction.onClick)
            },
            /*#__PURE__*/
            _react["default"].createElement(_HorizontalFlex.HorizontalFlex, null, subAction.iconClass &&
            /*#__PURE__*/
            _react["default"].createElement("span", {
              className: "".concat(subAction.iconClass, " menu-item-icon")
            }),
            /*#__PURE__*/
            _react["default"].createElement("span", {
              className: "menu-item-text"
            }, subAction.description)))
          );
        });
        return (
          /*#__PURE__*/
          _react["default"].createElement("div", {
            key: menuItem.sortOrder
          }, subActions, addDivider(index, props.hasDividers, props.menuItems))
        );
      }

      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          key: menuItem.sortOrder
        },
        /*#__PURE__*/
        _react["default"].createElement(_core.MenuItem, {
          disabled: menuItem.isDisabled || false,
          onClick: onMenuItemClick(menuItem.onClick)
        },
        /*#__PURE__*/
        _react["default"].createElement(_HorizontalFlex.HorizontalFlex, null, menuItem.iconClass &&
        /*#__PURE__*/
        _react["default"].createElement("span", {
          className: "".concat(menuItem.iconClass, " menu-item-icon")
        }),
        /*#__PURE__*/
        _react["default"].createElement("span", {
          className: "menu-item-text"
        }, menuItem.description))), addDivider(index, props.hasDividers, props.menuItems))
      );
    })))
  );
}
/* eslint-enable complexity */


Menu.propTypes = {
  anchorElement: _propTypes["default"].instanceOf(Object),
  anchorOrigin: _propTypes["default"].instanceOf(Object),
  hasDividers: _propTypes["default"].bool,
  menuItems: _propTypes["default"].instanceOf(Array).isRequired,
  onClose: _propTypes["default"].func.isRequired,
  transformOrigin: _propTypes["default"].instanceOf(Object)
};
Menu.defaultProps = {
  anchorOrigin: {
    horizontal: 'right',
    vertical: 'bottom'
  },
  hasDividers: true,
  transformOrigin: {
    horizontal: 'right',
    vertical: 'top'
  }
};